<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YnDs0Z/tc-custom/9781910859971.jpg?1717183259376" alt="This image is the cover for the book Waiting for Yesterday, Holidays at Home"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Waiting for Yesterday, Holidays at Home
      </h1>
      <p class="bookDescription body article font2">
        <p>  <b>Wartime dreams soar in this novel of ambition and resilience. Third in the World War II home front series from the author of <i>Swingboats on the Sand</i>.</b><br/>  <br/> Shirley Downs has always known she was no ordinary girl. But when she enters and wins a singing contest, she begins to realize that her talent is really something special. However, it is 1941, and a career on the stage comes second place to rationing and bomb threats. Nevertheless, Shirley is determined to succeed, and no-one will get in her way . . .<br/>  <br/><i>Waiting for Yesterday</i> is the third of the Holidays at Home books, a captivating series of wartime sagas from the much-loved author Grace Thompson.<br/>  <br/> Grace Thompson is an acclaimed author of saga and romance novels, and a mainstay of libraries throughout the United Kingdom and beyond. Born and raised in South Wales, she is the author of numerous series, including the Valley series, the Pendragon Island series, and the Badgers Brook series. She published her forty-second novel shortly after celebrating her eightieth birthday, and continues to live in Swansea. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Grace Thompson
      </h2>
      
      <p class="authorDescription body article"><P>Grace Thompson is a much-loved Welsh author of saga and romance novels, and a mainstay of libraries throughout the United Kingdom and beyond.</P><P>Born and raised in South Wales, she is the author of numerous series, including the Valley series, the Pendragon Island series, and the Badger’s Brook series. She published her 42nd novel shortly after celebrating her 80th birthday, and continues to live in Swansea.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Digital Publishing Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?be4a596a